import { createContext, useContext } from 'react';
import type { OrderTypeToSoundMapType } from './SoundProviderUtils';

interface SoundContextProps {
  playSound: (sound: OrderTypeToSoundMapType, force?: boolean) => void;
  playSoundThrottled: (sound: OrderTypeToSoundMapType, force?: boolean) => void;
}
export const SoundContext = createContext<SoundContextProps | null>(null);
SoundContext.displayName = 'SoundContext';

export function useSounds() {
  const context = useContext(SoundContext);
  if (context == null) {
    throw new Error('Missing SoundContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
}
